/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as DemandAssignmentRouteImport } from './routes/demand-assignment'
import { Route as DemandGroupsRouteImport } from './routes/demand-groups'
import { Route as DemandTargetAllocationGroupsRouteImport } from './routes/demand-target-allocation-groups'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as ReceivingRouteImport } from './routes/receiving'
import { Route as SkusRouteImport } from './routes/skus'
import { Route as StoresRouteImport } from './routes/stores'
import { Route as SuppliersRouteImport } from './routes/suppliers'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const DemandAssignmentRoute = DemandAssignmentRouteImport.update({
  id: '/demand-assignment',
  path: '/demand-assignment',
  getParentRoute: () => rootRouteImport,
} as any)
const DemandGroupsRoute = DemandGroupsRouteImport.update({
  id: '/demand-groups',
  path: '/demand-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const DemandTargetAllocationGroupsRoute =
  DemandTargetAllocationGroupsRouteImport.update({
    id: '/demand-target-allocation-groups',
    path: '/demand-target-allocation-groups',
    getParentRoute: () => rootRouteImport,
  } as any)
const LocationsRoute = LocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const ReceivingRoute = ReceivingRouteImport.update({
  id: '/receiving',
  path: '/receiving',
  getParentRoute: () => rootRouteImport,
} as any)
const SkusRoute = SkusRouteImport.update({
  id: '/skus',
  path: '/skus',
  getParentRoute: () => rootRouteImport,
} as any)
const StoresRoute = StoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersRoute = SuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/categories': typeof CategoriesRoute
  '/demand-assignment': typeof DemandAssignmentRoute
  '/demand-groups': typeof DemandGroupsRoute
  '/demand-target-allocation-groups': typeof DemandTargetAllocationGroupsRoute
  '/locations': typeof LocationsRoute
  '/receiving': typeof ReceivingRoute
  '/skus': typeof SkusRoute
  '/stores': typeof StoresRoute
  '/suppliers': typeof SuppliersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/categories': typeof CategoriesRoute
  '/demand-assignment': typeof DemandAssignmentRoute
  '/demand-groups': typeof DemandGroupsRoute
  '/demand-target-allocation-groups': typeof DemandTargetAllocationGroupsRoute
  '/locations': typeof LocationsRoute
  '/receiving': typeof ReceivingRoute
  '/skus': typeof SkusRoute
  '/stores': typeof StoresRoute
  '/suppliers': typeof SuppliersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/categories': typeof CategoriesRoute
  '/demand-assignment': typeof DemandAssignmentRoute
  '/demand-groups': typeof DemandGroupsRoute
  '/demand-target-allocation-groups': typeof DemandTargetAllocationGroupsRoute
  '/locations': typeof LocationsRoute
  '/receiving': typeof ReceivingRoute
  '/skus': typeof SkusRoute
  '/stores': typeof StoresRoute
  '/suppliers': typeof SuppliersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/categories'
    | '/demand-assignment'
    | '/demand-groups'
    | '/demand-target-allocation-groups'
    | '/locations'
    | '/receiving'
    | '/skus'
    | '/stores'
    | '/suppliers'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/categories'
    | '/demand-assignment'
    | '/demand-groups'
    | '/demand-target-allocation-groups'
    | '/locations'
    | '/receiving'
    | '/skus'
    | '/stores'
    | '/suppliers'
  id:
    | '__root__'
    | '/'
    | '/callback'
    | '/categories'
    | '/demand-assignment'
    | '/demand-groups'
    | '/demand-target-allocation-groups'
    | '/locations'
    | '/receiving'
    | '/skus'
    | '/stores'
    | '/suppliers'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CallbackRoute: typeof CallbackRoute
  CategoriesRoute: typeof CategoriesRoute
  DemandAssignmentRoute: typeof DemandAssignmentRoute
  DemandGroupsRoute: typeof DemandGroupsRoute
  DemandTargetAllocationGroupsRoute: typeof DemandTargetAllocationGroupsRoute
  LocationsRoute: typeof LocationsRoute
  ReceivingRoute: typeof ReceivingRoute
  SkusRoute: typeof SkusRoute
  StoresRoute: typeof StoresRoute
  SuppliersRoute: typeof SuppliersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand-assignment': {
      id: '/demand-assignment'
      path: '/demand-assignment'
      fullPath: '/demand-assignment'
      preLoaderRoute: typeof DemandAssignmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand-groups': {
      id: '/demand-groups'
      path: '/demand-groups'
      fullPath: '/demand-groups'
      preLoaderRoute: typeof DemandGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand-target-allocation-groups': {
      id: '/demand-target-allocation-groups'
      path: '/demand-target-allocation-groups'
      fullPath: '/demand-target-allocation-groups'
      preLoaderRoute: typeof DemandTargetAllocationGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations': {
      id: '/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof LocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/receiving': {
      id: '/receiving'
      path: '/receiving'
      fullPath: '/receiving'
      preLoaderRoute: typeof ReceivingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/skus': {
      id: '/skus'
      path: '/skus'
      fullPath: '/skus'
      preLoaderRoute: typeof SkusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores': {
      id: '/stores'
      path: '/stores'
      fullPath: '/stores'
      preLoaderRoute: typeof StoresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers': {
      id: '/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof SuppliersRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CallbackRoute: CallbackRoute,
  CategoriesRoute: CategoriesRoute,
  DemandAssignmentRoute: DemandAssignmentRoute,
  DemandGroupsRoute: DemandGroupsRoute,
  DemandTargetAllocationGroupsRoute: DemandTargetAllocationGroupsRoute,
  LocationsRoute: LocationsRoute,
  ReceivingRoute: ReceivingRoute,
  SkusRoute: SkusRoute,
  StoresRoute: StoresRoute,
  SuppliersRoute: SuppliersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
